const statisticsAcquisition = {
  en: {
    translation: {
      customers_map_description:
        "The map shows the areas where foodiestrip customers viewed your business. The color of the field varies in intensity (red indicates the highest search density) depending on the number of customers",
      customers_map_title: "Views of your business",
      you_are_here: "You are here",
      search_results: "Search results",
      within_250m: "Within 250m",
      within_1km: "Within 1km",
      within_5km: "Within 5km",
      within_more_than_5km: "Within more than 5km",
      total: "Total",
      search_results_tooltip_description:
        "The data shows the number of views of your page based on the distance of possible customers from your business. It is a fundamental statistic to activate proximity marketing campaigns in real time",
      views_recevied_at: "Week views received at ",
      weekly_views: "Weekly views",
      daily_views: "Daily views",
      daily_clicks: "Daily clicks",
      views: "Views",
      views_and_clicks: "Views and clicks",
      other_ideal_for_title:
        "The foodies that have looked for you prefer businesses ideal for:",
      other_ideal_for_text:
        "Your customers' preferences allow you to understand which services you can implement to attract them and what kind of clientele you need to extend your turnover",
      impressions_chart_title: "Trends and time of the 'impressions'",
      search_by_week_description:
        "The graphic shows the daily trend of the 'impressions' (i.e., the times that your page appears as a result of user searches)."
    }
  },
  it: {
    translation: {
      customers_map_description:
        "La mappa illustra le zone da cui i clienti di foodiestrip hanno visualizzato la tua attività. Il colore della zona varia di intensità (il rosso segnala la densità di ricerca maggiore) a seconda del numero di clienti.",
      customers_map_title: "Visualizzazioni della tua struttura",
      you_are_here: "Tu sei qui",
      search_results: "Risultati di ricerca",
      within_250m: "Nel raggio di 250m",
      within_1km: "Nel raggio di 1km",
      within_5km: "Nel raggio di 5km",
      within_more_than_5km: "Nel raggio maggiore di 5km",
      total: "Totale",
      search_results_tooltip_description:
        "Il dato indica il numero di visualizzazioni della tua pagina in base alla distanza dei possibili clienti dal tuo locale. Si tratta di una statistica fondamentale per attivare campagne di proximity marketing in tempo reale",
      views_recevied_at: "Visite della settimana ricevute alle ",
      weekly_views: "Visualizzazioni settimanali",
      daily_views: "Visualizzazioni giornaliere",
      daily_clicks: "Click giornalieri",
      views: "Visualizzazioni",
      views_and_clicks: "Visualizzazioni e click",
      other_ideal_for_title:
        "I foodies che ti hanno cercato prediligono strutture ideali per:",
      other_ideal_for_text:
        "Le preferenze dei tuoi clienti ti permettono di comprendere quali servizi puoi implementare per attirarli e a che tipo di clientela rivolgerti per allargare il giro d'affari",
      impressions_chart_title: "Andamento e fasce orarie delle 'impression'",
      search_by_week_description:
        "Il grafico mostra l'andamento giornaliero delle 'impression' (ossia le volte che la tua pagina compare in seguito alle ricerche degli utenti)."
    }
  }
};

export default statisticsAcquisition;
